module.exports = __webpack_public_path__ + "static/media/image-card-5.b669a891.png";